export const enum userConstants  {
  roleUserRequest = "ROLE_USER_REQUEST",
  roleUserSuccess = "ROLE_USER_SUCCESS",
  roleUserFailure = "ROLE_USER_FAILURE",

  userCreateRequest = "USER_CREATE_REQUEST",
  userCreateSuccess = "USER_CREATE_SUCCESS",
  userCreateFailure = "USER_CREATE_FAILURE",
  userCreateReset = "USER_CREATE_RESET",

  userListRequest = "USER_LIST_REQUEST",
  userListSuccess = "USER_LIST_SUCCESS",
  userListFailure = "USER_LIST_FAILURE",

  userUpdateRequest = "USER_UPDATE_REQUEST",
  userUpdateSuccess = "USER_UPDATE_SUCCESS",
  userUpdateFailure = "USER_UPDATE_FAILURE",

  userViewRequest = "USER_VIEW_REQUEST",
  userViewSuccess = "USER_VIEW_SUCCESS",
  userViewFailure = "USER_VIEW_FAILURE",

  getProfileRequest= "GET_PROFILE_REQUEST",
  getProfileSuccess= "GET_PROFILE_SUCCESS",
  getProfileFailure= "GET_PROFILE_FAILURE",
  

  updateProfileRequest = "UPDATE_PROFILE_REQUEST",
  updateProfileSuccess = "UPDATE_PROFILE_SUCCESS",
  updateProfileFailure = "UPDATE_PROFILE_FAILURE",

  uploadProfileImageRequest = "UPLOAD_PROFILE_IMAGE_REQUEST",
  uploadProfileImageSuccess = "UPLOAD_PROFILE_IMAGE_SUCCESS",
  uploadProfileImageFailure = "UPLOAD_PROFILE_IMAGE_FAILURE",

  getTermsByTypeRequest = "GET_TERMS_BY_TYPE_REQUEST",
  getTermsByTypeSuccess = "GET_TERMS_BY_TYPE_SUCCESS",
  getTermsByTypeFailure = "GET_TERMS_BY_TYPE_FAILURE",
};